import enums from '@happylife-a/enums';
import http, { API_CORE } from '../http';

const headerKey = enums.httpHeaders.HttpClientHeaderEnum.ApiTenantIdentifier;

export default function BrandingService() {
  const getBrandingConfigs = async (tenantIdentifier = null) => {
    const headers = {};
    if (tenantIdentifier) {
      headers[headerKey] = tenantIdentifier;
    }

    const response = await http(API_CORE).get('/branding', { headers });
    return response.data;
  };

  const updateBrandingConfigs = async (variables) => {
    const { environments, translations, logos } = variables;

    // Check if we have logo files to upload
    const hasLogos = logos && Object.values(logos).some((logo) => logo instanceof File);

    if (hasLogos) {
      // Use FormData for multipart upload
      const formData = new FormData();
      formData.append('environments', JSON.stringify(environments));
      formData.append('translations', JSON.stringify(translations));

      // Append logo files
      Object.entries(logos).forEach(([key, file]) => {
        if (file instanceof File) {
          formData.append(key, file);
        }
      });

      const response = await http(API_CORE).put('/branding', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    } else {
      // Regular JSON request when no logos
      const response = await http(API_CORE).put('/branding', {
        environments,
        translations,
      });

      return response.data;
    }
  };

  return {
    getBrandingConfigs: getBrandingConfigs,
    updateBrandingConfigs: updateBrandingConfigs,
  };
}
